@if (newEditor.show) {
<app-new-editor
  #newEditorRef
  [template]="templateData"
  [variables]="variables"
  [title]="'Email Editor'"
  (EditorStateChanged)="onEditorStateChanged($event)"></app-new-editor>
}
<div class="page-designer-toolbar" [style.width.px]="panelCollapsed ? 0 : panelWidth" xmlns="http://www.w3.org/1999/html">
  <div class="page-designer-toolbar-container" cdkDropListGroup>
    <div class='p-0 bg-white h-100 mt-3'>
      <div class="row px-3 pt-3 pb-1 mb-3 ms-4">
        <div class="col-12">
          <div class="form-check form-check-native">
            <input class="form-check-input" type="checkbox" id="sendsEmailCheckbox"
                   [checked]="sendsEmail" (change)="sendsEmail = !sendsEmail; onSendsEmailChange()">
            <label class="form-check-label fw-bold" for="sendsEmailCheckbox">This campaign sends email</label>
          </div>
        </div>
      </div>
      @if (sendsEmail) {
      <div class='w-100'>
        @if (sectionsStatus["email"]) {
          <div class="row">
            <div class='col-md-11 mx-auto d-none'>
              <p>Email to your influencers asking them to promote their participation. It's a win-win</p>
            </div>
          </div>
          <form [formGroup]="campaignForm">
            <div class="row">
              <div class='col-md-10 mb-3 mx-auto'>
                <div class="d-flex align-items-center">
                  <small>From Name</small>
                </div>
                <div class='input-group input-group-sm'>
                  <input id="name" class="form-control" placeholder="" type="text" [disabled]='isTestEmailDisable'
                         formControlName="email_from_name">
                </div>
                @if (submitted && f.email_from_name.errors) {
                <div class="bar error-brd">
                  @if (f.email_from_name.errors.required) {
                  <div class="invalid-text">Email From Name is required</div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="row d-none">
              <div class='col-md-10 mx-auto customize-email'>
                <input id="customize" placeholder="" type="checkbox" (change)="customizeFromAddress()" [disabled]='isTestEmailDisable'
                       [checked]="this.campaignMeta.email_customized">
                <label for="customize">Customize From email</label>
              </div>
            </div>
            <div class="row">
              <div class='col-md-10 mb-3 mx-auto'>
                <div class="d-flex align-items-center">
                  <small>From Email</small>
                </div>
                <div class="split-email-field" [class.disabled]="isTestEmailDisable">
                  <input class="split-email-local"
                         type="text"
                         placeholder="name"
                         [value]="fromEmailLocal"
                         (input)="onFromEmailLocalChange($event.target.value)"
                         [disabled]="isTestEmailDisable">
                  <span class="split-email-at">&#64;</span>
                  <ng-select #fromDomainSelect
                             class="split-email-domain-select"
                             [items]="allowedDomains"
                             bindLabel="identity"
                             bindValue="identity"
                             [ngModel]="fromEmailDomain"
                             [ngModelOptions]="{standalone: true}"
                             (change)="onFromDomainChange($event)"
                             [clearable]="false"
                             [searchable]="false"
                             placeholder="domain.com"
                             [disabled]="isTestEmailDisable">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="domain-option">
                        <span class="domain-option-name">{{item.identity}}</span>
                        @if (item.service_provider?.slug !== 'no_email') {
                        <a
                           href="#"
                           class="domain-status-badge cursor-pointer"
                           [class.verified]="item.verification_status === 'verified'"
                           [class.unverified]="item.verification_status !== 'verified'"
                           (mousedown)="$event.stopPropagation()"
                           (click)="openDomainVerificationFromDropdown($event, item, fromDomainSelect)">
                          <i class="fa fa-external-link me-1" aria-hidden="true"></i>
                          {{item.verification_status === 'verified' ? 'Verified' : 'Unverified'}}
                        </a>
                        }
                        @if (item.service_provider?.slug === 'no_email') {
                        <span class="domain-verify-na text-muted">N/A</span>
                        }
                      </div>
                    </ng-template>
                    <ng-template ng-footer-tmp>
                      <div class="domain-dropdown-footer">
                        @if (canAddMailerDomain) {
                        <button
                                type="button"
                                class="btn btn-link btn-sm domain-add-domain-btn"
                                (mousedown)="$event.stopPropagation()"
                                (click)="navigateToAddMailerDomain($event, fromDomainSelect)">
                          <i class="fa fa-plus me-1" aria-hidden="true"></i>
                          Add new domain
                        </button>
                        }
                        @if (!canAddMailerDomain) {
                        <p class="domain-dropdown-footer-hint mb-0">
                          To add a new domain, contact your project administrator.
                        </p>
                        }
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      {{item.identity}}
                    </ng-template>
                  </ng-select>
                </div>
                <input type="hidden" formControlName="email_from">
                @if (!isTestEmailDisable) {
                <div class="mt-1">
                  @if (fromEmailDomain) {
                    @if (fromEmailVerified === 'verified') {
                    <span class="badge text-bg-success cursor-pointer" (click)="showVerificationStatus()"
                         >
                      Verified (Click to update)
                    </span>
                    }
                    @if (fromEmailVerified === 'unverified') {
                    <span class="badge text-bg-danger cursor-pointer" (click)="showVerificationStatus()"
                         >
                      Unverified (Click to verify)
                    </span>
                    }
                  }
                  @if (!fromEmailDomain) {
                  <span class="pick-domain-btn cursor-pointer"
                        (click)="openFromDomainDropdown(fromDomainSelect)">
                    Pick a valid domain
                  </span>
                  }
                </div>
                }
                @if (submitted && f.email_from.errors) {
                <div class="bar error-brd">
                  @if (f.email_from.errors.required) {
                  <div class="invalid-text">Email From is required</div>
                  }
                  @if (f.email_from.errors.email) {
                  <div class="invalid-text">Invalid email address</div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="row">
              <div class='col-md-10 mb-3 mx-auto'>
                <div class="d-flex align-items-center">
                  <small>Reply To Email</small>
                </div>
                <div class="split-email-field" [class.disabled]="isTestEmailDisable">
                  <input class="split-email-local"
                         type="text"
                         placeholder="name"
                         [value]="replyToEmailLocal"
                         (input)="onReplyToEmailLocalChange($event.target.value)"
                         [disabled]="isTestEmailDisable">
                  <span class="split-email-at">&#64;</span>
                  <ng-select #replyToDomainSelect
                             class="split-email-domain-select"
                             [items]="allowedDomains"
                             bindLabel="identity"
                             bindValue="identity"
                             [ngModel]="replyToEmailDomain"
                             [ngModelOptions]="{standalone: true}"
                             (change)="onReplyToDomainChange($event)"
                             [clearable]="false"
                             [searchable]="false"
                             placeholder="domain.com"
                             [disabled]="isTestEmailDisable">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="domain-option">
                        <span class="domain-option-name">{{item.identity}}</span>
                        @if (item.service_provider?.slug !== 'no_email') {
                        <a
                           href="#"
                           class="domain-status-badge cursor-pointer"
                           [class.verified]="item.verification_status === 'verified'"
                           [class.unverified]="item.verification_status !== 'verified'"
                           (mousedown)="$event.stopPropagation()"
                           (click)="openDomainVerificationFromDropdown($event, item, replyToDomainSelect)">
                          <i class="fa fa-external-link me-1" aria-hidden="true"></i>
                          {{item.verification_status === 'verified' ? 'Verified' : 'Unverified'}}
                        </a>
                        }
                        @if (item.service_provider?.slug === 'no_email') {
                        <span class="domain-verify-na text-muted">N/A</span>
                        }
                      </div>
                    </ng-template>
                    <ng-template ng-footer-tmp>
                      <div class="domain-dropdown-footer">
                        @if (canAddMailerDomain) {
                        <button
                                type="button"
                                class="btn btn-link btn-sm domain-add-domain-btn"
                                (mousedown)="$event.stopPropagation()"
                                (click)="navigateToAddMailerDomain($event, replyToDomainSelect)">
                          <i class="fa fa-plus me-1" aria-hidden="true"></i>
                          Add new domain
                        </button>
                        }
                        @if (!canAddMailerDomain) {
                        <p class="domain-dropdown-footer-hint mb-0">
                          To add a new domain, contact your project administrator.
                        </p>
                        }
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      {{item.identity}}
                    </ng-template>
                  </ng-select>
                </div>
                <input type="hidden" formControlName="email_reply_to">
                @if (!isTestEmailDisable) {
                <div class="mt-1">
                  @if (replyToEmailDomain) {
                    @if (replyToEmailVerified === 'verified') {
                    <span class="badge text-bg-success cursor-pointer" (click)="showReplyToVerificationStatus()"
                         >
                      Verified (Click to update)
                    </span>
                    }
                    @if (replyToEmailVerified === 'unverified') {
                    <span class="badge text-bg-danger cursor-pointer" (click)="showReplyToVerificationStatus()"
                         >
                      Unverified (Click to verify)
                    </span>
                    }
                  }
                  @if (!replyToEmailDomain) {
                  <span class="pick-domain-btn cursor-pointer"
                        (click)="openReplyToDomainDropdown(replyToDomainSelect)">
                    Pick a valid domain
                  </span>
                  }
                </div>
                }
                @if (submitted && f.email_reply_to.errors) {
                <div class="bar error-brd">
                  @if (f.email_reply_to.errors.required) {
                  <div class="invalid-text">Email reply to is required</div>
                  }
                  @if (f.email_reply_to.errors.email) {
                  <div class="invalid-text">Invalid email address</div>
                  }
                </div>
                }
              </div>
            </div>
            @if (hasRestrictedDomain) {
            <div class="row mb-5">
              <div class="col-md-10 mx-auto">
                <div class="invalid-text">Please use an email address from your own domain (e.g., &#64;example.com) for the 'From' and 'Reply-To'</div>
              </div>
            </div>
            }
            <div class="row">
              <div class='col-md-10 mb-3 mx-auto'>
                <div class="d-flex align-items-center">
                  <small>Subject Line</small>
                  <app-variables
                    (onVariableForClick)="onAddVariablesButtonClick($event)" [variableClickFor]="'email_subject'"
                    [isDisabled]="isTestEmailDisable"
                    (onVariableClick)="onVariableClick($event, subject)"
                  ></app-variables>
                  <app-sb-text-condition-button [target]="subject" [disabled]="isTestEmailDisable"></app-sb-text-condition-button>
                  <app-rtl-embedding-button (clicked)="applyRTLEmbedding()"></app-rtl-embedding-button>
                </div>
                <div class='input-group input-group-sm variable-input'>
                  <textarea class="form-control overflow-hidden auto-grow-textarea" #subject
                            id="subject_line" placeholder="" type="text" (input)="autoGrow(subject)"
                            formControlName="email_subject"
                            ></textarea>
                  <!--                    <app-variables-->
                </div>
                <app-sb-text-condition-hint [text]="f.email_subject.value" [target]="subject" [disabled]="isTestEmailDisable"></app-sb-text-condition-hint>
                @if (f.email_subject.errors?.maxlength; as tooLong) {
                <div class="bar error-brd" data-subject-too-long>
                  <div class="invalid-text">The subject line is {{ tooLong.actualLength }} characters long and the limit is {{ tooLong.requiredLength }}. Variables and conditions count as written.</div>
                </div>
                }
                @if (submitted && f.emails_source_message.errors) {
                <div class="bar error-brd">
                  @if (f.emails_source_message.errors.required) {
                  <div class="invalid-text">Email subject is required</div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="row">
              <div class='col-md-10 mb-3 mx-auto'>
                <div class="d-flex align-items-center">
                  <small>Email Source Message</small>
                  <app-variables
                    (onVariableForClick)="onAddVariablesButtonClick($event)" [variableClickFor]="'emails_source_message'"
                    [isDisabled]="isTestEmailDisable"
                    (onVariableClick)="onVariableClick($event, emails_source_message)"
                  ></app-variables>
                  <app-rtl-embedding-button (clicked)="applyRTLEmbedding()"></app-rtl-embedding-button>
                </div>
                <div class='input-group input-group-sm variable-input'>
                  <textarea class="form-control overflow-hidden auto-grow-textarea" #emails_source_message
                            id="emails_source_message" [placeholder]="" type="text" (input)="autoGrow(emails_source_message)"
                            formControlName="emails_source_message"
                  ></textarea>
                  <!--                    <app-variables-->
                </div>
                @if (submitted && f.emails_source_message.errors) {
                <div class="bar error-brd">
                  @if (f.emails_source_message.errors.required) {
                  <div class="invalid-text">Email source message is required</div>
                  }
                </div>
                }
              </div>
            </div>
          </form>
          @if (!newEditor.active) {
          <div class="row">
            <div class='col-md-10 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small>Button Text</small>
<!--                <app-variables-->
              </div>
              <div class='input-group input-group-sm variable-input'>
                <input id="buttonText" class="form-control" placeholder="" type="text" [(ngModel)]="buttonText" [autocomplete]="randomStr" [disabled]='isTestEmailDisable'>
                <!--                  <app-variables-->
              </div>
            </div>
          </div>
          }
          @if (!newEditor.active) {
          <div class="row">
            <div class='col-md-10 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small>Button Color</small>
              </div>
              <div class='input-group input-group-sm custom-color-picker'>
                <input id="background_color" style="height: 30px;" [value]="buttonColor" [(ngModel)]="buttonColor" [autocomplete]="randomStr" [disabled]='isTestEmailDisable'
                       type="text" class='form-control border-0'
                       appColorPicker (change)="buttonColor = $event.target.value"/>
              </div>
            </div>
          </div>
          }
          @if (!newEditor.active) {
          <div class="row">
            <div class='col-md-10 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small>Button Text Color</small>
              </div>
              <div class='input-group input-group-sm custom-color-picker'>
                <input id="button_font_color" style="height: 30px;" [value]="buttonTextColor" [(ngModel)]="buttonTextColor" [autocomplete]="randomStr" [disabled]='isTestEmailDisable'
                       type="text" class='form-control border-0'
                       appColorPicker (change)="buttonTextColor = $event.target.value"/>
              </div>
            </div>
          </div>
          }
          @if (!newEditor.active) {
          <div class="row">
            <div class='col-md-10 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small>Background Color</small>
              </div>
              <div class='input-group input-group-sm custom-color-picker'>
                <input id="email_background_color" style="height: 30px;" [value]="emailBackgroundColor" [autocomplete]="randomStr" [disabled]='isTestEmailDisable'
                       [(ngModel)]="emailBackgroundColor"
                       type="text" class='form-control border-0'
                       appColorPicker (change)="emailBackgroundColor = $event.target.value"/>
              </div>
            </div>
          </div>
          }
          @if (!newEditor.active) {
          <div class="row">
            <div class='col-md-10 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small>Link Color</small>
              </div>
              <div class='input-group input-group-sm custom-color-picker'>
                <input id="link_color" style="height: 30px;" [value]="linkColor" [(ngModel)]="linkColor" [autocomplete]="randomStr" [disabled]='isTestEmailDisable'
                       type="text" class='form-control border-0'
                       appColorPicker (change)="linkColor = $event.target.value"/>
              </div>
            </div>
          </div>
          }
<!--                       [(ngModel)]="paragraphSpacing" data-field='max_width'-->
<!--                       data-unit="px"/>-->
<!--                       [(ngModel)]="buttonSpacing" data-field='max_width'-->
<!--                       data-unit="px"/>-->
          <div class="row" style="display: none">
            <div class='col-md-10 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Share Link</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <input class="form-control" type='text' [disabled]="isTestEmailDisable || !campaignMeta['share_link_customized']"
                       [(ngModel)]="campaignMeta['share_link']"/>
                <div class="inputs">
                  <app-variables
                    [isDisabled]="!campaignMeta['share_link_customized']"
                    [variableClickFor]="'share_link'"
                    [fieldType]="'url'"
                    (onVariableClick)="updateValue($event, 'share_link')"
                  ></app-variables>
                </div>
              </div>
            </div>
          </div>
          <div class='row' style="display: none">
            <div class='col-md-10 mx-auto customize-email text-center'>
              <button class="btn btn-primary btn-sm" type="button" (click)="shareWidgetPreview()">
                Share Widget Preview
              </button>
            </div>
          </div>

          <div class="p-3 email-body" style="display: none">
            <app-social-share-preview class="smaller-text" [socialMedia]="'Facebook'"
                                      [title]="$safeNavigationMigration(campaignMeta?.title)"
                                      [image]="campaignMeta?.image_template && campaign?.social_template?.thumbnail ? campaign.social_template.thumbnail : $safeNavigationMigration(campaignMeta?.image)"
                                      [message]="campaignMeta?.social_networks?.facebook?.message || 'Your message here'"
                                      [description]="campaignMeta?.description || 'Your description here...'"
                                      [url]="campaign ? campaign.project.subdomain : 'my-event.snoball.events'">
            </app-social-share-preview>
          </div>
        }
      </div>
      }
    </div>
  </div>
</div>
@if (!panelCollapsed) {
<div class="toolbar-panel-resize-handle"
     [style.left]="panelWidth + 'px'"
     (pointerdown)="startResizing($event)">
</div>
}
<button class="toolbar-panel-toggle-button"
        [style.left]="(panelCollapsed ? 0 : panelWidth) + 'px'"
        (click)="togglePanel()">
  {{ panelCollapsed ? '▶' : '◀' }}
</button>
<div  class="right-content" [style.marginLeft.px]="panelCollapsed ? 0 : panelWidth" style="transition: margin-left 0.3s;">
  <app-page-shell variant="wizard" [stickyChrome]="true" [withOps]="true">
  <div pageChrome>
    <app-status-bar [loading]="loader$ | async" [step]="step" [skipLanding]="campaign?.landing_page_status === 'skipped'"
                        (SaveButtonClick)="onSaveButtonClick()"></app-status-bar>
  </div>
@if (sendsEmail) {
<div class="card card-box card-margin custom-fullscreen-card">
          <div class="card-header py-3">
            <div class="card-header--title">
              <div class="row">
                <div class="col-md-12">
                  <span class="font-size-lg fw-bold">The Ask Email</span> <span class="font-size-md ms-2"> Email your influencers to tell them to promote the campaign. It's a
                  win-win</span>
                </div>
              </div>
            </div>
            <div class="card-header--actions pull-right">
            </div>
          </div>
          <div class="card-body pb-0">
            @if (!newEditor.active) {
            <div class='row custom-card-body'>
              <div class="col-10">
                <small><b>From Name:</b> {{campaignForm.value.email_from_name}}</small><br/>
                <small><b>From Email:</b> {{campaignForm.value.email_from || 'no-reply@snoball.it'}}
                </small><br/>
                <small><b>Reply To:</b> {{campaignForm.value.email_reply_to || '(not set)'}}
                </small><br/>
                <small><b>Subject Line:</b> {{campaignForm.value.email_subject}}</small><br/>
              </div>
              <div class="col-2">
              </div>
            </div>
            }
            @if (!newEditor.active) {
            <br/>
            }
            <div class="row bg-heavy-rain">
              @if (template && variableLoaded) {
              <div class='col-12' style="padding: 0;">
                @if (newEditor.active) {
                <app-new-editor-preview [template]="templateData" [influencerPreview]="true"
                                        [emailHeader]="{
                                          fromName: campaignForm.value.email_from_name,
                                          fromEmail: campaignForm.value.email_from || 'no-reply@snoball.it',
                                          replyTo: campaignForm.value.email_reply_to || '(not set)',
                                          subject: campaignForm.value.email_subject
                                        }"
                                        [emailsSourceMessage]="campaignForm.value.emails_source_message || ''">
                </app-new-editor-preview>
                }

                @if (!newEditor.active) {
                <app-editor #editor [template]='template' [customVariables]='variables'
                            [templateButtonText]="buttonText"
                            [templateButtonTextColor]="buttonTextColor"
                            [templateButtonSpacing]="buttonSpacing"
                            [templateListSpacing]="listSpacing"
                            [templateParagraphSpacing]="paragraphSpacing"
                            [templateButtonColor]="buttonColor"
                            [templateLinkColor]="linkColor"
                            [templateLinkHoverColor]="linkHoverColor"
                            [templateBackgroundColor]="emailBackgroundColor"
                            [templateButtonLink]="campaignMeta['share_link']" (isEditorLoaded)='editorLoaded = $event'
                            [influencerTypeId]='influencerType' [allowReordering]='false' [onChange]='onEditorChange'>
                </app-editor>
                }
              </div>
              }
            </div>
          </div>
        </div>
}
</app-page-shell>
</div>
<div class="operation-box">
  <div class="col-md-12">
    <div class="row">
      <div class="col d-flex justify-content-left align-items-center">
        <div class="text-start">
          <button (click)="onBackButtonClick()" class="btn btn-default me-2" type="button">
            Back
          </button>
          @if (this.template?.id) {
          <button [disabled]="!editorLoaded"
                  class="btn btn-default me-2"
                  (click)="showTemplateRevisions()">
            Undo All
          </button>
          }
          @if (this.template?.id && !newEditor.show) {
          <button
                  class="btn btn-default"
                  (click)="showNewEditor()">
            {{ (newEditor.active || this.template?.visual_editor_id) ? 'Edit' : 'Edit In New Editor' }}
          </button>
          }
        </div>
      </div>
      <div class="col d-flex justify-content-center align-items-center">
        <div class="text-center">
          <small>Sending to <b>{{influencerCount}} influencers</b> ({{this.influencerType?.name}}) in segment
            <b>{{this.campaign?.segments?.[0]?.name || ''}}</b></small>
        </div>
      </div>
      <div class="col d-flex justify-content-end align-items-center">
        <div class="text-end">
          <button [disabled]="isTestEmailDisable || (loader$ | async) || !editorLoaded" (click)="onSendTestEmailButtonClick()"
                  class="btn btn-default me-2"
                  type="button">
              <span>@if ((loader$ | async) || !editorLoaded) {
<i class="fa fa-spinner fa-spin me-2"
                      ></i>
}Send Test Email</span>
          </button>
          <button [disabled]="(loader$ | async) || !editorLoaded"
                  class="btn btn-default me-2 d-none" (click)="previewEmailTemplate()"
                  type="button">
            <span>@if ((loader$ | async) || !editorLoaded) {
<i class="fa fa-spinner fa-spin me-2"
                    ></i>
}Preview</span>
          </button>
          <button [disabled]="(loader$ | async) || !editorLoaded" (click)="onNextButtonClick()"
                  class="btn btn-primary me-2" type="button">
            <span>@if ((loader$ | async) || !editorLoaded) {
<i class="fa fa-spinner fa-spin me-2"></i>
}Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #sendTestEmail let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Send a test email</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click');"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="testMailForm" class=" w-100">
          <div class="mt-4 mx-0 w-100">
            @for (recipient of testMailForm.get('recipients')['controls']; track recipient; let i = $index) {
            <div
              class="w-100"
              formArrayName="recipients"
             >
              <div [formGroupName]="i" class="mt-2 w-100 position-relative">
                <input  type="email"
                        [class.minusIcon]="i >=1"
                        class="px-2 w-100 input" formControlName="email" placeholder="Email Address" autoComplete="none">
                <div class=" position-absolute h-100 cursor-pointer" [class.floating-element]="i >=1" (click)="removeRecipient(i)"></div>
              </div>
            </div>
            }
            <button  class="input add-recipient no-box-shadow mt-2 ps-2 w-100 text-start" type="button" (click)="addRecipient()">Add Another Email</button>
                </div>
        </form>
<!--                 type="email"/>-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="floating-label">
          <input class="floating-input"  (keydown.enter)="sendTestEmails(modal)" [(ngModel)]="sampleInfluencerEmail"
                 (ngModelChange)="sampleInfluencerEmailError = ''" placeholder=" "
                 type="email"/>
          <span class="highlight"></span>
          <label>Sample influencer email</label>
          @if (sampleInfluencerEmailError) {
          <div class="bar error-brd">
            <div class="invalid-text">{{sampleInfluencerEmailError}}</div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-11 customize-email include-checkbox'>
        <input id="customizePage" placeholder="" type="checkbox"
               [(ngModel)]="isIncludeContent">
        <label for="customizePage">Include additional content (optional)</label>
      </div>
    </div>
    @if (isIncludeContent) {
    <div class="row">
      <div class="col-md-12">
        <textarea class="form-control auto-grow-textarea email-textarea" [(ngModel)]="additionalContent"
                  id="additional_content" placeholder="" type="text" rows="8">
        </textarea>
      </div>
    </div>
    }
  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button (click)="modal.dismiss('Close clicked');" class="btn btn-default me-2">
      <span>Cancel</span>
    </button>
    <button type="submit" (click)="sendTestEmails(modal)" class="btn btn-primary me-2">
      <span>Send test</span>
    </button>
  </div>
</ng-template>
